import { render, staticRenderFns } from "./SendBokkingCon.vue?vue&type=template&id=30cb8edb&scoped=true&"
import script from "./SendBokkingCon.vue?vue&type=script&lang=js&"
export * from "./SendBokkingCon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb8edb",
  null
  
)

export default component.exports